/**
 * Mutable PostHog session ids for Sentry beforeSend + setTag. Same pattern for web and mobile.
 */
export function createPosthogSentrySessionLink(posthogHost) {
    let sessionId = null;
    let distinctId = null;
    return {
        setSessionLink(id, dId) {
            sessionId = id;
            distinctId = dId ?? null;
        },
        clearLinkedSession() {
            sessionId = null;
            distinctId = null;
        },
        mergeIntoEvent(event) {
            if (!sessionId) {
                return event;
            }
            const e = event;
            e.contexts = {
                ...e.contexts,
                posthog: {
                    session_id: sessionId,
                    distinct_id: distinctId,
                    session_replay_url: posthogHost ? `${posthogHost}/replay/${sessionId}` : undefined,
                },
            };
            e.tags = {
                ...e.tags,
                posthog_session_id: sessionId,
            };
            return event;
        },
        applyTagsIfActive(setTag) {
            if (sessionId) {
                setTag("posthog_session_id", sessionId);
                if (distinctId) {
                    setTag("posthog_distinct_id", distinctId);
                }
            }
        },
    };
}
